<template>
   <div
      v-if="$config.public.mode === 'preview'"
      class="bg-yellow flex items-center justify-center py-1 text-black"
   >
      <p class="h-s">TEST ENVIRONMENT - NOT FOR PRODUCTION USE</p>
   </div>
</template>
